module.exports = __webpack_public_path__ + "static/media/APPDownload.54bc427e.png";